const DeletedCustomer = () =>
  import('@/views/main/wechatMgmt/deletedCustomer/DeletedCustomer.vue')
export default {
  path: '/main/wechatMgmt/deletedCustomer',
  name: 'DeletedCustomer',
  component: DeletedCustomer
}
